import React, { useEffect, useState } from 'react'
import StatusOrders from './components/StatusOrders'
import { RouteOrders } from './components/RouteOrders'
import { CityOrders } from './components/CityOrders'
import { PriceData } from './components/PriceData'
import { ProductOrders } from './components/ProductOrders'
import { DateRangePicker } from 'react-date-range';
import { addDays } from 'date-fns';
import axios from 'axios'
import Input from '../../components/Input'
import { getDateFormat, getValidDateFormat } from '../../helpers/utils'
import Loader from '../../components/Loader'
import { TeamOrders } from './components/TeamOrders'
import { RepOrders } from './components/RepOrders'
import { UpdateChart } from './components/UpdateChart'
import { RoutePoints } from './components/RoutePoints'
import { CityPoints } from './components/CityPoints'
import { TeamPoints } from './components/TeamPoints'
import { BsClipboard2, BsClipboard2X } from 'react-icons/bs'
import { IoClipboardOutline } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { Pie } from 'react-chartjs-2';
import { TeaChart } from './components/TeaChart'

export default function Dashboard() {
  
  const [type,setType] = useState('1D')
  const [counts,setCounts] = useState('')
  const [analytics,setAnalytics] = useState(null)
  const [startDate,setStartDate] = useState('')
  const [endDate,setEndDate] = useState('')
  const [loading,setLoading] = useState(false)
  const [teaAnalytics,setTeaAnalytics] = useState([])
  const authInfo = useSelector(state=>state.auth)


  // const onPress = (value) => {
  //   const today = new Date();
  //   setType(value)
  //   if (value === '1D') {
  //     // Set startDate and endDate to today
  //     setStartDate(today);
  //     setEndDate(today);
  //   } else if (value === '1M') {
  //     // Calculate startDate as 1 month before today
  //     const oneMonthAgo = new Date(today);
  //     oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

  //     setStartDate(oneMonthAgo);
  //     setEndDate(today);
  //   } else if (value === '1W') {
  //     // Calculate startDate as 1 week before today
  //     const oneWeekAgo = new Date(today);
  //     oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

  //     setStartDate(oneWeekAgo);
  //     setEndDate(today);
  //   }
  // };

  const onPress = (value) => {
    const today = new Date();
    setType(value);
  
    if (value === '1D') {
      // Set startDate and endDate to today
      setStartDate(today);
      setEndDate(today);
    } else if (value === '1W') {
      // Calculate startDate as 1 week before today
      const oneWeekAgo = new Date(today);
      oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  
      setStartDate(oneWeekAgo);
      setEndDate(today);
    } else if (value === '1M') {
      // Calculate startDate as 1 month before today
      const oneMonthAgo = new Date(today);
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  
      setStartDate(oneMonthAgo);
      setEndDate(today);
    } else if (value === '3M') {
      // Calculate startDate as 3 months before today
      const threeMonthsAgo = new Date(today);
      threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
  
      setStartDate(threeMonthsAgo);
      setEndDate(today);
    } else if (value === '6M') {
      // Calculate startDate as 6 months before today
      const sixMonthsAgo = new Date(today);
      sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
  
      setStartDate(sixMonthsAgo);
      setEndDate(today);
    } else if (value === '1Y') {
      // Calculate startDate as 1 year before today
      const oneYearAgo = new Date(today);
      oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
  
      setStartDate(oneYearAgo);
      setEndDate(today);
    } else if (value === 'All') {
      // Set both startDate and endDate to empty strings
      setStartDate('');
      setEndDate('');
    }
  };
  

  useEffect(()=>
  {
    async function getOrderAnalytics()
    {
      if (type === '1D')
      {
        const today = new Date();
        let query = ''
        query +=`startDate=${getValidDateFormat(today)}`
        query +=`&endDate=${getValidDateFormat(today)}`;
        let res = await axios.get(`${process.env.REACT_APP_BASE_URL}/analytics/daily?${query}`)
        setAnalytics(res.data)
        setLoading(false)
      }
      else
      {

        let query = ''
        if(startDate) query +=`startDate=${getValidDateFormat(startDate)}`
        if(endDate) query +=`&endDate=${getValidDateFormat(endDate)}`;
        let res = await axios.get(`${process.env.REACT_APP_BASE_URL}/analytics/daily?${query}`)
        setAnalytics(res.data)
        setLoading(false)
      }
    }
    getOrderAnalytics()
  },[startDate,endDate])

  useEffect(()=>
  {
    async function getCounts()
    {
        let res = await axios.get(`${process.env.REACT_APP_BASE_URL}/analytics/total`)
        setCounts(res.data)
    }
    async function getTeaAnalytics()
    {
        let res = await axios.get(`${process.env.REACT_APP_BASE_URL}/analytics/tea`)
        setTeaAnalytics(res.data)
    }
    getCounts()
    getTeaAnalytics()
  },[])


  const tabItems = [{label:'This Month',value:'this_month'},{label:'Last Month',value:'last_month'}]
  const [activeTab,setActiveTab] = useState('this_month')
  return (
    !loading ? <div className='px-6 py-4 overflow-scroll bg-[#efefef]'>
        <div className='my-4 flex justify-between items-center'>

        <div className="grid grid-cols-5 w-full flex-wrap gap-y-3 bg-white border border-gray-200 overflow-hidden rounded-md">
          <div className='border-r border-gray-200 py-6 px-6'>
            <p className='text-2xl font-bold mb-0'>{counts?.totalSalesOrder ? counts.totalSalesOrder : '-'}</p>
            <p className='text-sm font-medium text-[#959595] mt-0'>Sales Orders</p>
          </div>
          <div className='border-r border-gray-200 py-6 px-6'>
            <p className='text-2xl font-bold mb-0'>{counts?.totalPurchaseOrder ? counts.totalPurchaseOrder : '-'}</p>
            <p className='text-sm font-medium text-[#959595] mt-0'>Purchase Orders</p>
          </div>
          <div className='border-r border-gray-200 py-6 px-6'>
            <p className='text-2xl font-bold mb-0'>{counts?.totalProductionOrder ? counts.totalProductionOrder : '-'}</p>
            <p className='text-sm font-medium text-[#959595] mt-0'>Production Orders</p>
          </div>
          <div className='border-r border-gray-200 py-6 px-6'>
            <p className='text-2xl font-bold mb-0'>{counts?.totalBuyers ? counts.totalBuyers : '-'}</p>
            <p className='text-sm font-medium text-[#959595] mt-0'>Buyers</p>
          </div>
          <div className='border-r border-gray-200 py-6 px-6'>
            <p className='text-2xl font-bold mb-0'>{counts?.totalSuppliers ? counts.totalSuppliers : '-'}</p>
            <p className='text-sm font-medium text-[#959595] mt-0'>Suppliers</p>
          </div>
        </div>

        

        </div>

        { authInfo.role === 'admin' || authInfo.role === 'tea' ? <div>
          <div className='w-full col-span-4 flex items-center'>
              <TeaChart data={teaAnalytics}/>
          </div>
        </div> : null}
        
        <AnalyticsByPeriod analytics={analytics} type={type} onPress={onPress} startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate}/>
        <div className='grid grid-cols-2 mt-4'>
          {authInfo.role === 'admin' || authInfo.role === 'production' ? <div className='col-start-0 col-span-2 w-auto h-auto'>
            {analytics?.production ? <UpdateChart data={analytics?.production} type='production'/> : null}
          </div> : null}  
          {authInfo.role === 'admin' || authInfo.role === 'purchase' ? <div className='col-start-0 col-span-2 w-auto h-auto my-4'>
            {analytics?.purchase ? <UpdateChart data={analytics?.purchase} type='purchase'/> : null}
          </div> : null}
          {authInfo.role === 'admin' || authInfo.role === 'sales' ? <div className='col-start-0 col-span-2 w-auto h-auto'>
            {analytics?.shipping ? <UpdateChart data={analytics?.shipping} type='shipping'/> : null}
          </div> : null}
        </div>


    </div> : <div className='flex items-center justify-center h-screen w-full'>
          <Loader/>
        </div>
  )
}




const AnalyticsByPeriod = ({analytics,type,onPress,startDate,endDate,setStartDate,setEndDate})=>
{
  return(
    <div className='flex justify-between items-center w-full'>
    <p className='text-sm font-medium tracking-tight  text-gray-700'>Analytics {analytics?.orderStatuses?.totalOrders}</p>
        <div className=' flex justify-end items-center'>
            <div className='relative flex mr-4 bg-white border border-gray-200 rounded-md overflow-hidden'>
              <div className={`px-3 py-2 periodTabItem border-r border-gray-200 transition-colors cursor-pointer text-[#757575] hover:bg-[#2ac08b] hover:text-white ${type === '1D' ? 'bg-[#2ac08b] text-white' : ''}`} onClick={()=>onPress('1D')}>
                <p className='text-xs font-medium capitalize tracking-tight'>1D</p>
              </div>
              <div className={`px-3 py-2 periodTabItem border-r border-gray-200 transition-colors cursor-pointer text-[#757575] hover:bg-[#2ac08b] hover:text-white ${type === '1W' ? 'bg-[#2ac08b] text-white' : ''}`} onClick={()=>onPress('1W')}>
                <p className='text-xs font-medium capitalize tracking-tight'>1W</p>
              </div>
              <div className={`px-3 py-2 periodTabItem border-r border-gray-200 transition-colors cursor-pointer text-[#757575] hover:bg-[#2ac08b] hover:text-white ${type === '1M' ? 'bg-[#2ac08b] text-white' : ''}`} onClick={()=>onPress('1M')}>
                <p className='text-xs font-medium capitalize  tracking-tight'>1M</p>
              </div>
              <div className={`px-3 py-2 periodTabItem border-r border-gray-200 transition-colors cursor-pointer text-[#757575] hover:bg-[#2ac08b] hover:text-white ${type === '3M' ? 'bg-[#2ac08b] text-white' : ''}`} onClick={()=>onPress('3M')}>
                <p className='text-xs font-medium capitalize  tracking-tight'>3M</p>
              </div>
              <div className={`px-3 py-2 periodTabItem border-r border-gray-200 transition-colors cursor-pointer text-[#757575] hover:bg-[#2ac08b] hover:text-white ${type === '6M' ? 'bg-[#2ac08b] text-white' : ''}`} onClick={()=>onPress('6M')}>
                <p className='text-xs font-medium capitalize  tracking-tight'>6M</p>
              </div>
              <div className={`px-3 py-2 periodTabItem border-r border-gray-200 transition-colors cursor-pointer text-[#757575] hover:bg-[#2ac08b] hover:text-white ${type === '1Y' ? 'bg-[#2ac08b] text-white' : ''}`} onClick={()=>onPress('1Y')}>
                <p className='text-xs font-medium capitalize tracking-tight'>1Y</p>
              </div>
              <div className={`px-3 py-2 periodTabItem border-r border-gray-200 transition-colors cursor-pointer text-[#757575] hover:bg-[#2ac08b] hover:text-white ${type === 'All' ? 'bg-[#2ac08b] text-white' : ''}`} onClick={()=>onPress('All')}>
                <p className='text-xs font-medium capitalize tracking-tight'>All</p>
              </div>
              </div>
            <div className='relative flex  bg-white border border-gray-200 rounded-md overflow-hidden'>
              <div onClick={()=>onPress(true)} className='border-r'>
              {/* <Input type='date' placeholder={'Select Start Date'} value={startDate} setValue={(value)=>setStartDate(value)}/> */}
              <input className='px-3 py-2 periodTabItem mb-0 text-[12px]' type='date' placeholder={'Select Start Date'} value={startDate} onChange={(e)=>setStartDate(e.target.value)}/>
              </div>
              <div onClick={()=>onPress(true)}>
              <input className='px-3 py-2 periodTabItem mb-0 text-[12px]' type='date' placeholder={'Select End Date'} value={endDate} onChange={(e)=>setEndDate(e.target.value)}/>
              </div>
              </div>
        </div>

    </div>
  )

}